import FortnoxClient from "./client";
import {
  ConfirmImportRequest,
  ErrorResponse,
  ImportStatusResponse,
} from "./models";

class FortnoxImportClient extends FortnoxClient {
  constructor(apiEndpoint: string) {
    super(apiEndpoint);
  }

  public async newImport(): Promise<
    [ImportStatusResponse | ErrorResponse, Response]
  > {
    const response = await this.fetch(this.getApiUrl("NewImport"), {
      method: "POST",
    });
    const jsonResponse = await response.json();

    return [jsonResponse, response];
  }

  public async status(
    importId: string
  ): Promise<[ImportStatusResponse | ErrorResponse, Response]> {
    const response = await this.fetch(this.getApiUrl("Status", importId));
    const jsonResponse = await response.json();

    return [jsonResponse, response];
  }

  public async cancelImport(
    importId: string
  ): Promise<[ErrorResponse | null, Response]> {
    const response = await this.fetch(this.getApiUrl("Cancel", importId), {
      method: "POST",
    });

    let errorData;
    try {
      errorData = await response.json();
    } catch {
      errorData = null;
    }

    return [errorData, response];
  }

  public async keepAlive(): Promise<[null, Response]> {
    const response = await this.fetch(this.getApiUrl("KeepAlive"));
    return [null, response];
  }

  public async confirmImport(
    importId: string,
    data: ConfirmImportRequest
  ): Promise<[ImportStatusResponse | ErrorResponse, Response]> {
    const response = await this.fetch(
      this.getApiUrl("ConfirmImport", importId),
      {
        method: "POST",
        body: JSON.stringify(data),
      }
    );
    return [await response.json(), response];
  }
}

export default FortnoxImportClient;
